import React from 'react';
import { withRouter } from 'react-router-dom';

import { getCenter } from 'helpers/zonesHelpers';
import { withZones } from '../Zones';
import render from './render';

export class ZonesView extends React.Component {
  static defaultProps = {
    render,
  };

  state = {}

  componentDidMount () {
    const { location: { pathname } } = this.props;
    const [, id] = pathname.match(/zone\/(\w+)$/) || [];
    this.selectZoneById({ id });
  }

  componentDidUpdate ({ location: { pathname: prevPathname } }) {
    const { location: { pathname } } = this.props;
    const [, id] = pathname.match(/zone\/(\w+)$/) || [];
    const [, prevId] = prevPathname.match(/zone\/(\w+)$/) || [];

    if (id !== prevId) {
      this.selectZoneById(id);
    }
  }

  get selectedZone () {
    const { zones } = this.props;

    if (!zones) return null;

    if (this.id) {
      return zones.features.find(({ properties: { tmpId } }) => tmpId === this.id);
    }

    if (this.props.selectedZone) {
      return this.props.selectedZone;
    }

    return null;
  }

  selectZone = ({ feature: { properties: { tmpId } } }) => {
    const { match: { path }, history: { push } } = this.props;
    push(`${path}/zone/${tmpId}`);
  }

  selectZoneById (id) {
    const { selectZoneById } = this.props;
    selectZoneById(id);
  }

  render () {
    const { render: Render, selectedZone, zones, ...nextProps } = this.props;
    const { selectZone } = this;

    if (!zones) return null;

    const center = getCenter(selectedZone
      ? [selectedZone]
      : zones.features);
    const zoom = selectedZone ? 10 : 8;
    const props = {
      ...nextProps,
      zones,
      center,
      zoom,
      selectZone,
      selectedZone,
    };

    return <Render {...props} />;
  }
}

export default withZones(withRouter(ZonesView));



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/ZonesView/index.js